<template>
  <div>
    <!-- Start blog-posts Area -->
    <section class="blog-posts-area section-padding">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 post-list blog-post-list">
            <div class="single-post">
              <img class="img-fluid" src="static/assets/images/p1.jpg" alt="">
              <ul class="tags">
                <li><a href="#">Art</a></li>
                <li><a href="#">Technology</a></li>
                <li><a href="#">Fashion</a></li>
              </ul>
              <a href="#">
                <h2>
                  Cartridge Is Better Than Ever
                  A Discount Toner
                </h2>
              </a>
              <div class="content-wrap">
                <p>
                  MCSE boot camps have its supporters and its detractors. Some people do not understand why you should have to spend money on boot camp when you can get the MCSE study materials yourself at a fraction of the camp price. However, who has the willpower to actually sit through a self-imposed MCSE training. who has the willpower to actually sit through a self-imposed MCSE training.
                </p>

                <p>
                  MCSE boot camps have its supporters and its detractors. Some people do not understand why you should have to spend money on boot camp when you can get the MCSE study materials yourself at a fraction of the camp price. However, who has the willpower to actually sit through a self-imposed MCSE training. who has the willpower to actually sit through a self-imposed MCSE training.
                </p>

                <blockquote class="generic-blockquote">
                  “Recently, the US Federal government banned online casinos from operating in America by making it illegal to transfer money to them through any US bank or payment system. As a result of this law, most of the popular online casino networks such as Party Gaming and PlayTech left the United States. Overnight, online casino players”
                </blockquote>

                <p>
                  MCSE boot camps have its supporters and its detractors. Some people do not understand why you should have to spend money on boot camp when you can get the MCSE study materials yourself at a fraction of the camp price. However, who has the willpower to actually sit through a self-imposed MCSE training. who has the willpower to actually sit through a self-imposed MCSE training.
                </p>

                <p>
                  MCSE boot camps have its supporters and its detractors. Some people do not understand why you should have to spend money on boot camp when you can get the MCSE study materials yourself at a fraction of the camp price. However, who has the willpower to actually sit through a self-imposed MCSE training. who has the willpower to actually sit through a self-imposed MCSE training.
                </p>


              </div>
              <!-- <div class="bottom-meta">
                  <div class="user-details row align-items-center">
                      <div class="comment-wrap col-lg-6 col-sm-6">
                          <ul>
                              <li><a href="#"><span class="lnr lnr-heart"></span>	4 likes</a></li>
                              <li><a href="#"><span class="lnr lnr-bubble"></span> 06 Comments</a></li>
                          </ul>
                      </div>
                      <div class="social-wrap col-lg-6">
                          <ul>
                              <li><a href="#"><i class="fa fa-facebook"></i></a></li>
                              <li><a href="#"><i class="fa fa-twitter"></i></a></li>
                              <li><a href="#"><i class="fa fa-dribbble"></i></a></li>
                              <li><a href="#"><i class="fa fa-behance"></i></a></li>
                          </ul>

                      </div>
                  </div>
              </div> -->

              <!-- Start nav Area -->
              <section class="nav-area py-5">
                <div class="container">
                  <div class="row justify-content-between">
                    <div class="col-sm-6 nav-left justify-content-start d-flex">
                      <div class="thumb">
                        <img src="static/assets/images/prev.jpg" alt="">
                      </div>
                      <div class="post-details">
                        <p>Prev Post</p>
                        <h4 class="text-uppercase"><a href="#">A Discount Toner</a></h4>
                      </div>
                    </div>
                    <div class="col-sm-6 nav-right justify-content-end d-flex">
                      <div class="post-details">
                        <p>Prev Post</p>
                        <h4 class="text-uppercase"><a href="#">A Discount Toner</a></h4>
                      </div>
                      <div class="thumb">
                        <img src="static/assets/images/next.jpg" alt="">
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <!-- End nav Area -->

              <!-- Start comment-sec Area -->
              <section class="comment-sec-area py-5">
                <div class="container">
                  <div class="row flex-column">
                    <h5 class="text-uppercase pb-80">05 Comments</h5>
                    <br>
                    <div class="comment-list">
                      <div class="single-comment justify-content-between d-flex">
                        <div class="user justify-content-between d-flex">
                          <div class="thumb">
                            <img src="static/assets/images/c1.jpg" alt="">
                          </div>
                          <div class="desc">
                            <h5><a href="#">Emilly Blunt</a></h5>
                            <p class="date">December 4, 2017 at 3:12 pm </p>
                            <p class="comment">
                              Never say goodbye till the end comes!
                            </p>
                          </div>
                        </div>
                        <div class="reply-btn">
                          <a href="" class="btn-reply text-uppercase">reply</a>
                        </div>
                      </div>
                    </div>
                    <div class="comment-list left-padding">
                      <div class="single-comment justify-content-between d-flex">
                        <div class="user justify-content-between d-flex">
                          <div class="thumb">
                            <img src="static/assets/images/c2.jpg" alt="">
                          </div>
                          <div class="desc">
                            <h5><a href="#">Emilly Blunt</a></h5>
                            <p class="date">December 4, 2017 at 3:12 pm </p>
                            <p class="comment">
                              Never say goodbye till the end comes!
                            </p>
                          </div>
                        </div>
                        <div class="reply-btn">
                          <a href="" class="btn-reply text-uppercase">reply</a>
                        </div>
                      </div>
                    </div>
                    <div class="comment-list left-padding">
                      <div class="single-comment justify-content-between d-flex">
                        <div class="user justify-content-between d-flex">
                          <div class="thumb">
                            <img src="static/assets/images/c3.jpg" alt="">
                          </div>
                          <div class="desc">
                            <h5><a href="#">Emilly Blunt</a></h5>
                            <p class="date">December 4, 2017 at 3:12 pm </p>
                            <p class="comment">
                              Never say goodbye till the end comes!
                            </p>
                          </div>
                        </div>
                        <div class="reply-btn">
                          <a href="" class="btn-reply text-uppercase">reply</a>
                        </div>
                      </div>
                    </div>
                    <div class="comment-list">
                      <div class="single-comment justify-content-between d-flex">
                        <div class="user justify-content-between d-flex">
                          <div class="thumb">
                            <img src="static/assets/images/c4.jpg" alt="">
                          </div>
                          <div class="desc">
                            <h5><a href="#">Emilly Blunt</a></h5>
                            <p class="date">December 4, 2017 at 3:12 pm </p>
                            <p class="comment">
                              Never say goodbye till the end comes!
                            </p>
                          </div>
                        </div>
                        <div class="reply-btn">
                          <a href="" class="btn-reply text-uppercase">reply</a>
                        </div>
                      </div>
                    </div>
                    <div class="comment-list">
                      <div class="single-comment justify-content-between d-flex">
                        <div class="user justify-content-between d-flex">
                          <div class="thumb">
                            <img src="static/assets/images/c5.jpg" alt="">
                          </div>
                          <div class="desc">
                            <h5><a href="#">Emilly Blunt</a></h5>
                            <p class="date">December 4, 2017 at 3:12 pm </p>
                            <p class="comment">
                              Never say goodbye till the end comes!
                            </p>
                          </div>
                        </div>
                        <div class="reply-btn">
                          <a href="" class="btn-reply text-uppercase">reply</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <!-- End comment-sec Area -->

              <!-- Start commentform Area -->
              <div class="commentform-area py-5">
                <form action="#">
                  <div class="left">
                    <input type="text" placeholder="Enter your name" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Enter your name'" required>
                    <input type="email" placeholder="Enter email address" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Enter email address'" required>
                    <input type="text" placeholder="Enter subject" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Enter subject'" required>
                  </div>
                  <div class="right">
                    <textarea name="message" cols="20" rows="7"  placeholder="Enter Message" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Enter Message'" required></textarea>
                  </div>
                  <button type="submit" class="template-btn">subscribe now</button>
                </form>
              </div>
              <!-- End commentform Area -->


            </div>
          </div>
          <div class="col-lg-4 sidebar mt-5 mt-lg-0">
            <div class="single-widget search-widget">
              <form class="example" action="#" style="margin:auto;max-width:300px">
                <input type="text" placeholder="Search Posts" name="search2">
                <button type="submit"><i class="fa fa-search"></i></button>
              </form>
            </div>

            <div class="single-widget protfolio-widget">
              <img src="static/assets/images/user2.jpg" alt="">
              <a href="#"><h4>Adele Gonzalez</h4></a>
              <p>
                MCSE boot camps have its supporters and
                its detractors. Some people do not understand why you should have to spend money
                on boot camp.
              </p>
              <ul>
                <li><a href="#"><i class="fa fa-facebook"></i></a></li>
                <li><a href="#"><i class="fa fa-twitter"></i></a></li>
                <li><a href="#"><i class="fa fa-dribbble"></i></a></li>
                <li><a href="#"><i class="fa fa-behance"></i></a></li>
              </ul>
            </div>

            <div class="single-widget category-widget">
              <h4 class="title">Post Categories</h4>
              <ul>
                <li><a href="#" class="justify-content-between align-items-center d-flex"><h6>Techlology</h6> <span>37</span></a></li>
                <li><a href="#" class="justify-content-between align-items-center d-flex"><h6>Lifestyle</h6> <span>24</span></a></li>
                <li><a href="#" class="justify-content-between align-items-center d-flex"><h6>Fashion</h6> <span>59</span></a></li>
                <li><a href="#" class="justify-content-between align-items-center d-flex"><h6>Art</h6> <span>29</span></a></li>
                <li><a href="#" class="justify-content-between align-items-center d-flex"><h6>Food</h6> <span>15</span></a></li>
                <li><a href="#" class="justify-content-between align-items-center d-flex"><h6>Architecture</h6> <span>09</span></a></li>
                <li><a href="#" class="justify-content-between align-items-center d-flex"><h6>Adventure</h6> <span>44</span></a></li>
              </ul>
            </div>

            <div class="single-widget recent-posts-widget">
              <h4 class="title">Recent Posts</h4>
              <div class="blog-list ">
                <div class="single-recent-post d-flex flex-row">
                  <div class="recent-thumb">
                    <img class="img-fluid" src="static/assets/images/r1.jpg" alt="">
                  </div>
                  <div class="recent-details">
                    <a href="blog-single.html">
                      <h4>
                        Home Audio Recording
                        For Everyone
                      </h4>
                    </a>
                    <p>
                      02 hours ago
                    </p>
                  </div>
                </div>
                <div class="single-recent-post d-flex flex-row">
                  <div class="recent-thumb">
                    <img class="img-fluid" src="static/assets/images/r2.jpg" alt="">
                  </div>
                  <div class="recent-details">
                    <a href="blog-single.html">
                      <h4>
                        Home Audio Recording
                        For Everyone
                      </h4>
                    </a>
                    <p>
                      02 hours ago
                    </p>
                  </div>
                </div>
                <div class="single-recent-post d-flex flex-row">
                  <div class="recent-thumb">
                    <img class="img-fluid" src="static/assets/images/r3.jpg" alt="">
                  </div>
                  <div class="recent-details">
                    <a href="blog-single.html">
                      <h4>
                        Home Audio Recording
                        For Everyone
                      </h4>
                    </a>
                    <p>
                      02 hours ago
                    </p>
                  </div>
                </div>
                <div class="single-recent-post d-flex flex-row">
                  <div class="recent-thumb">
                    <img class="img-fluid" src="static/assets/images/r4.jpg" alt="">
                  </div>
                  <div class="recent-details">
                    <a href="blog-single.html">
                      <h4>
                        Home Audio Recording
                        For Everyone
                      </h4>
                    </a>
                    <p>
                      02 hours ago
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="single-widget category-widget">
              <h4 class="title">Post Archive</h4>
              <ul>
                <li><a href="#" class="justify-content-between align-items-center d-flex"><h6>Dec '17</h6> <span>37</span></a></li>
                <li><a href="#" class="justify-content-between align-items-center d-flex"><h6>Nov '17</h6> <span>24</span></a></li>
                <li><a href="#" class="justify-content-between align-items-center d-flex"><h6>Oct '17</h6> <span>59</span></a></li>
                <li><a href="#" class="justify-content-between align-items-center d-flex"><h6>Sep '17</h6> <span>29</span></a></li>
                <li><a href="#" class="justify-content-between align-items-center d-flex"><h6>Aug '17</h6> <span>15</span></a></li>
                <li><a href="#" class="justify-content-between align-items-center d-flex"><h6>Jul '17</h6> <span>09</span></a></li>
                <li><a href="#" class="justify-content-between align-items-center d-flex"><h6>Jun '17</h6> <span>44</span></a></li>
              </ul>
            </div>

            <div class="single-widget tags-widget">
              <h4 class="title">Tag Clouds</h4>
              <ul>
                <li><a href="#">Lifestyle</a></li>
                <li><a href="#">Art</a></li>
                <li><a href="#">Adventure</a></li>
                <li><a href="#">Food</a></li>
                <li><a href="#">Techlology</a></li>
                <li><a href="#">Fashion</a></li>
                <li><a href="#">Architecture</a></li>
                <li><a href="#">Food</a></li>
                <li><a href="#">Technology</a></li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </section>
    <!-- End blog-posts Area -->
  </div>
</template>

<script>
  export default {}
</script>




// WEBPACK FOOTER //
// BlogDetails.vue?4b0ba336